<template>
    <div id='over'>
        <img src="/static/img/over.png" alt="">
        <p style="font-size: 18px;">
           当前系统繁忙，请客官稍候再试
        </p>
        <div class="theme-bd gohome theme-bg" @click='gohome'>
            返回首页
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods:{
        gohome(){
            this.$router.push({ name: "Home"});
        }
    },
    mounted() {
    }
}
</script>

<style lang="less" scoped>
#over{
    position: relative;
    width: 100%;
    img{
        height: 100vh;
    }
    p{  
        text-align: center;
        width: 404px;
        position: absolute;
        top: 65%;
        left: 50%;
        margin-left: -202px;
    }
    div{
        position: absolute;
        top: 70%;
        left: 50%;
        margin-left: -80px;
        line-height: 30px;;
        font-size: 20px;
        width: 160px;
        border-radius: 20px;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/overtime.vue